if (!customElements.get("video-lightbox")) {
	class VideoLightbox extends DeferredMedia {
		constructor() {
			super();
			this.dialog = this.querySelector("dialog, [role=dialog]");
		}

		open() {
			this.dialog.showModal();
			this.addListeners();
		}

		close() {
			this.dialog.close();
			this.removeListeners();
		}

		addDialogCloseClass() {
			this.dialog.classList.add("close");
		}

		removeDialogCloseClass() {
			this.dialog.classList.remove("close");
			this.close()
		}

		onDialogClose() {
			this.addDialogCloseClass();
			this.reset();
			this.dialog.addEventListener("animationend", this.removeDialogCloseClass.bind(this), { once: true });
		}

		keyBoardClose(event) {
			event.preventDefault();
			if (event.type === "keydown" && event.key !== "Escape") return;

			this.onDialogClose();
		}

		onClickOutside(event) {
			const isInDialog = () => {
				const rect = this.dialog.getBoundingClientRect();
				const isInX = event.clientX >= rect.left && event.clientX <= rect.right;
				const isInY = event.clientY >= rect.top && event.clientY <= rect.bottom;
				return isInX && isInY;
			};

			const canClose = this.dialog.hasAttribute("open") && !isInDialog();

			if (!canClose) return;

			this.onDialogClose();
		}

		addListeners() {
			const closeButtons = this.dialog.querySelectorAll("[close]");
			closeButtons.forEach(button => {
				button.addEventListener("click", this.onDialogClose.bind(this));
			}, { once: true });
			window.addEventListener("click", this.onClickOutside.bind(this));
			window.addEventListener("keydown", this.keyBoardClose.bind(this));
			this.dialog.addEventListener("animationend", this.play.bind(this));
		}

		removeListeners() {
			window.removeEventListener("click", this.onClickOutside.bind(this));
			window.removeEventListener("keydown", this.keyBoardClose.bind(this));
			this.dialog.removeEventListener("animationend", this.play.bind(this));
		}

		connectedCallback() {
			super.connectedCallback = () => { };
		}
	}

	customElements.define("video-lightbox", VideoLightbox);
}